import axios from 'axios'
import router from '@/router'

const state = {
  token: localStorage.getItem('access_token') || null,
  user: JSON.parse(localStorage.getItem('user')) || null,
  userRole: localStorage.getItem('userRole') || null
}

const getters = {
  isAuthenticated: (state) => !!state.token,
  currentUser: (state) => state.user,
  userRole: (state) => state.userRole,
  // Kiểm tra quyền truy cập
  hasAccess: (state) => (requiredRole) => {
    const roleHierarchy = {
      admin: 4,
      manager: 3,
      technical: 2,
      hr: 1
    }
    return roleHierarchy[state.userRole] >= roleHierarchy[requiredRole]
  }
}

const actions = {
  // Khôi phục phiên đăng nhập
  async restoreSession({ commit }) {
    const token = localStorage.getItem('access_token')
    const user = JSON.parse(localStorage.getItem('user'))
    const userRole = localStorage.getItem('userRole')

    if (token && user && userRole) {
      commit('setToken', token)
      commit('setUser', user)
      commit('setUserRole', userRole)
      // Cập nhật axios header
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      return true
    }
    return false
  },

  // Refresh token
  async refreshToken({ commit }) {
    try {
      const refreshToken = localStorage.getItem('refresh_token')
      if (!refreshToken) throw new Error('No refresh token found')

      const response = await axios.post('/api/auth/refresh', null, {
        headers: {
          Authorization: `Bearer ${refreshToken}`,
          'Content-Type': 'application/json'
        }
      })

      const { access_token } = response.data
      
      if (!access_token) {
        throw new Error('Invalid refresh response')
      }

      // Cập nhật access token mới
      localStorage.setItem('access_token', access_token)
      commit('setToken', access_token)

      return access_token
    } catch (error) {
      // Xử lý lỗi refresh token
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('user')
      localStorage.removeItem('userRole')
      
      commit('setToken', null)
      commit('setUser', null)
      commit('setUserRole', null)
      
      delete axios.defaults.headers.common['Authorization']
      router.push('/login')
      
      throw error
    }
  },

  // Đăng nhập
  async login({ commit }, credentials) {
    try {
      const response = await axios.post('/auth/login', credentials)
      const { access_token, refresh_token, user } = response.data
      
      // Lưu thông tin vào localStorage
      localStorage.setItem('access_token', access_token)
      localStorage.setItem('refresh_token', refresh_token)
      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('userRole', user.role)
      
      // Cập nhật state
      commit('setToken', access_token)
      commit('setUser', user)
      commit('setUserRole', user.role)
      
      // Token sẽ được tự động thêm vào header bởi axios interceptor
      
      // Chuyển hướng sau khi đăng nhập thành công
      router.push('/dashboard')
      
      return true
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Đăng nhập thất bại')
    }
  },

  // Đăng xuất
  async logout({ commit }) {
    try {
      await axios.post('/auth/logout')
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      // Xóa thông tin khỏi localStorage
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
      localStorage.removeItem('user')
      localStorage.removeItem('userRole')
      
      // Reset state
      commit('setToken', null)
      commit('setUser', null)
      commit('setUserRole', null)
      
      // Xóa token khỏi axios header
      delete axios.defaults.headers.common['Authorization']
    }
  }
}

const mutations = {
  setToken(state, token) {
    state.token = token
  },
  setUser(state, user) {
    state.user = user
  },
  setUserRole(state, role) {
    state.userRole = role
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}